import * as React from "react";
const SvgSvgSwitch = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.836 2v1.488h5.617L9.83 12.111 3 18.941l.523.524.524.523 2.574-2.574 4.367-4.367 3.733 3.732 3.732 3.733h-5.618V22H20.989v-8.152H19.5v5.617l-3.732-3.733L12.035 12l3.733-3.732L19.5 4.535v5.617h1.488V2h-4.076Zm-8.79 2.012-.523.523L3 5.06l1.91 1.91 3.703 3.705.524-.526.525-.523-3.705-3.703Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSvgSwitch;
